/**
 * お問い合わせページへのリンク
 */
import { useTranslation } from "react-i18next";
/**
 * お問い合わせリンクコンポーネント
 * @returns お問い合わせリンクのJSX Element
 */
export const ContactLink: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="c-section">
      <h2 className="p-heading-2">{t("お問い合わせ")}</h2>
      <p className="c-link-list">
        <a
          href="http://www.gastec.co.jp/inquiry/"
          className="c-angle c-blank"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("ガステック お問い合わせページ")}
        </a>
      </p>
    </section>
  );
};
